export default "__VITE_ASSET__DNfLzO$r__"